// extracted by mini-css-extract-plugin
module.exports = {"iframe":"style_iframe__FIQDl"};